const savePaths = [
  {
    PATH: /ad\/finish/,
    TITLE: 'Looking good!',
    COPY: 'Enter your email address below to save your design and continue to the Design Lab.'
  },
  {
    PATH: /fundraising/,
    TITLE: 'Start a Fundraiser',
    COPY: 'Save your design to use it in your Fundraising campaign.'
  },
  {
    PATH: /gof/,
    TITLE: 'Start a Group Order',
    COPY: 'Save your design to use it in your Group Order Form.'
  },
  {
    PATH: /help/,
    COPY: 'Save your design so that you don’t lose your work.'
  },
  {
    PATH: /namesAndNumbers/,
    COPY: 'Your updated list will be saved when you save your design.'
  },
  {
    PATH: /saveConfirmation\?continue=true/,
    TITLE: 'Save your progress',
    COPY: 'Save your latest design and price for easy checkout.'
  },
  {
    PATH: /share/,
    COPY: 'Save your design to share it!'
  }
];
export const CANADA = 'CA';

export const ERROR_MESSAGES = {
  in_use: 'was used in a previous order. Please choose a different design name.'
};

export default savePaths;
